export const LOCATION__16 = '<svg data-id="SVG_LOCATION__16" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M8.3 1C5.3 1 3 3.4 3 6.3c0 4 4.5 8.7 5.3 8.7.8 0 5.3-4.8 5.3-8.7 0-3-2.4-5.3-5.3-5.3zm0 7.2a1.9 1.9 0 1 1 0-3.8 1.9 1.9 0 0 1 0 3.8z" fill="none" fill-rule="evenodd" stroke-linecap="round"></path></svg>';


// WEBPACK FOOTER //
// ./src/universal/components/svg-def/base-location.js